import React from "react";

const logline = <p>This is a sports/drama about two brothers whose relationship is severely tested when they find a winning lottery ticket that belongs to the captain of their play-off bound rugby team.</p>;

export default logline;